import { useContext } from 'react';
import { StratifiedProductionChartsDataContext } from '../contexts/StratifiedProductionChartsDataContext';

export const useStratifiedProductionChartsDataContext = () => {
    return useContext(StratifiedProductionChartsDataContext);
};
